class ProductTabs {
  constructor() {
    this.init();
  }

  init() {
    this.initTabSwitching();
  }

  initTabSwitching() {
    const tabButtons = document.querySelectorAll('.product-tab-btn');
    const tabContents = document.querySelectorAll('.product-tab-content');

    if (!tabButtons.length || !tabContents.length) return;

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const tabName = button.getAttribute('data-tab');
        const activeTabClass = button.getAttribute('data-active-class');
        const inactiveTabClass = button.getAttribute('data-inactive-class');
        const bottomLineClass = button.getAttribute('data-bottom-line-class');

        // Update active state for tab buttons
        tabButtons.forEach((btn) => {
          if (btn.getAttribute('data-tab') === tabName) {
            //btn.classList.add('t-font-bold');
            btn.classList.remove(inactiveTabClass);
            btn.classList.add(activeTabClass);
            btn.classList.remove('t-border-transparent');
            btn.classList.add(bottomLineClass);
            btn.setAttribute('aria-selected', 'true');
          } else {
            //btn.classList.remove('t-font-bold');
            btn.classList.remove(activeTabClass);
            btn.classList.add(inactiveTabClass);
            btn.classList.add('t-border-transparent');
            btn.classList.remove(bottomLineClass);
            btn.setAttribute('aria-selected', 'false');
          }
        });

        // Show the active tab content
        tabContents.forEach((content) => {
          if (content.getAttribute('data-tab') === tabName) {
            content.classList.remove('t-hidden');
            content.classList.add('t-block');
          } else {
            content.classList.add('t-hidden');
            content.classList.remove('t-block');
          }
        });
      });
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductTabs();
});
